export { default } from './SierraWidget.vue';